<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <ByPeriodReport />
  </Layout>
</template>

<script>
import ByPeriodReport from '@/components/Reports/Rents/ByPeriodReport.vue'
import Layout from '@/views/Layout'

export default {
  name: 'ReportsByPeriod',
  components: { Layout, ByPeriodReport },
  computed: {
    breadcrumbs: () => [
      { text: 'Início', to: { name: 'HomeIndex' } },
      { text: 'Relatórios', to: { name: 'ReportsIndex' } },
      { text: 'Por Período', to: { name: 'ReportsByPeriod' }, active: true }
    ]
  }
}
</script>
